module.exports = __webpack_public_path__ + "img/logo.cb9549e7.png";